module.exports = __webpack_public_path__ + "img/user.8db23da3.svg";